import { StreamChunk } from '../types/chat';

export interface ToolCall {
  name: string;
  status: string;
  description: string;
  started_at: string;
  completed_at?: string;
  error?: string;
}

export class ChatApiService {
  private baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8001';
  
  async healthCheck(): Promise<boolean> {
    try {
      const response = await fetch(`${this.baseUrl}/api/v1/health`);
      return response.ok;
    } catch {
      return false;
    }
  }

  async* streamChat(message: string, sessionId?: string): AsyncGenerator<StreamChunk> {
    const response = await fetch(`${this.baseUrl}/api/v1/chat/stream`, {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'Accept': 'text/event-stream'
      },
      body: JSON.stringify({ 
        message, 
        session_id: sessionId 
      })
    });

    if (!response.ok) {
      throw new Error(`API Error: ${response.status} ${response.statusText}`);
    }

    if (!response.body) {
      throw new Error('Stream not supported by browser');
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';

    try {
      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        const chunk = decoder.decode(value, { stream: true });
        buffer += chunk;
        
        const lines = buffer.split('\n');
        buffer = lines.pop() || '';

        for (const line of lines) {
          if (line.startsWith('data: ')) {
            const jsonStr = line.slice(6).trim();
            if (jsonStr && jsonStr !== '[DONE]') {
              try {
                yield JSON.parse(jsonStr) as StreamChunk;
              } catch (e) {
                console.warn('Failed to parse stream chunk:', jsonStr);
              }
            }
          }
        }
      }
      
      if (buffer.trim()) {
        const line = buffer.trim();
        if (line.startsWith('data: ')) {
          const jsonStr = line.slice(6).trim();
          if (jsonStr && jsonStr !== '[DONE]') {
            try {
              yield JSON.parse(jsonStr) as StreamChunk;
            } catch (e) {
              console.warn('Failed to parse final stream chunk:', jsonStr);
            }
          }
        }
      }
    } finally {
      reader.releaseLock();
    }
  }
}

export const chatApi = new ChatApiService();
